export default {
  namespaced: true,
  state: {
    isModalVisible: false,
    modalType: null,
    modalData: null,
    modalInterviewType: null,
    modalInterviewId: null,
  },
  mutations: {
    SHOW_MODAL(state, {
      type, data, interviewType, interviewId,
    }) {
      state.isModalVisible = true;
      state.modalType = type;
      state.modalData = data;
      state.modalInterviewType = interviewType;
      state.modalInterviewId = interviewId;
    },
    HIDE_MODAL(state) {
      state.isModalVisible = false;
      setTimeout(() => {
        state.modalType = null;
        state.modalData = null;
        state.modalInterviewType = null;
        state.modalInterviewId = null;
      }, 200);
    },
  },
  actions: {
    showAddCandidateModal({ commit }, {
      type, data, interviewType, interviewId,
    }) {
      commit('SHOW_MODAL', {
        type, data, interviewType, interviewId,
      });
    },
    hideAddCandidateModal({ commit }) {
      commit('HIDE_MODAL');
    },
  },
  getters: {
    isAddCandidateModalVisible: (state) => state.isModalVisible,
    addCandidateModalType: (state) => state.modalType,
    addCandidateModalData: (state) => state.modalData,
    addCandidateModalInterviewType: (state) => state.modalInterviewType,
    addCandidateModalInterviewId: (state) => state.modalInterviewId,
  },
};
